import { ToastType } from './types';

let toasts: ToastType[] = [];
const listeners = new Set<() => void>();

export const toastStore = {
  subscribe(callback: () => void) {
    listeners.add(callback);
    return () => listeners.delete(callback);
  },
  getSnapshot() {
    return toasts;
  },
  addToast(config: ToastType) {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast = { ...config, id };
    toasts = [...toasts, newToast].slice(-5);
    this.emit();

    setTimeout(() => {
      this.removeToast(id);
    }, 5000);
  },
  removeToast(id: string) {
    toasts = toasts.filter((t: ToastType) => t.id !== id);
    this.emit();
  },
  emit() {
    listeners.forEach((callback) => callback());
  },
};

export const toast = (config: ToastType) => toastStore.addToast(config);
